export enum PackAndFocusEntityType {
  HABIT_PACK = 'habit-pack',
  FOCUS_TEMPLATE = 'focus-template'
}

export enum PackEditorMode {
  CREATE = 'create',
  EDIT = 'edit'
}

export enum PackPickerVariant {
  MY_PACKS = 'my-packs',
  MARKETPLACE = 'marketplace'
}

export enum MarketplaceEntityFilterValue {
  ALL = 'all',
  PACKS = 'packs',
  TEMPLATES = 'templates'
}

/** Ownership axis, orthogonal to the entity-type filter above. */
export enum MarketplaceOwnerFilterValue {
  EVERYONE = 'everyone',
  MINE = 'mine'
}

export enum FocusTemplateDetailsListType {
  ALLOWED_APPS = 'allowed_apps',
  ALLOWED_URLS = 'allowed_urls'
}
